import * as React from 'react';
import { useSelector } from 'react-redux';

import { SeoHeading } from '../../components/SeoHeading';
import { selectListingSeoData } from '../../selectors/listingOffers';

export interface ISeoHeadingContainerProps {
  className?: string;
}

export const SeoHeadingContainer: React.FC<ISeoHeadingContainerProps> = ({ className }) => {
  const seoData = useSelector(selectListingSeoData);
  const title = seoData?.h1;

  if (!title) {
    return null;
  }

  return <SeoHeading title={title} className={className} />;
};

SeoHeadingContainer.displayName = 'SeoHeadingContainer';
